module.exports = __webpack_public_path__ + "92b03e2368b4ffb209bec56b83136ea2.png";